export const [
    INIT_DOCUMENT_LOAD,
    SUBMIT_DOCUMENT_REQUEST,
    RESET_UPLOAD_STORE,
    ADD_DOCUMENTS_TO_STORE,
    SUBMIT_DOCUMENT_ONGOING,
    SUBMIT_DOCUMENT_SUCCESS,
    SUBMIT_DOCUMENT_FAILURE,
    RESET_UPLOAD_STATUS,
    SEND_ME_UPLOAD_LINK_REQUEST,
    QR_CODE_LINK_SUCCESS,
    SEND_ME_UPLOAD_LINK_VIA_SMS_REQUEST,
    UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS,
    FETCH_NEW_DOCUMENT_REQUEST,
    NEW_DOCS_TRUE,
    GO_BACK_TO_SURVEY,
    ADD_DERMATO_PHOTO,
    ADD_PHONE_PHOTO,
    CLEAR_UPLOAD_LINK,
    HYDRATE_UPLOAD,
    MARK_PHONE_PHOTO_DOCS_PROCESSED,
    CLEAR_PROCESSED_PHONE_PHOTO_DOCS,
    FETCH_DERMATO_PATIENT_DETAILS_REQUEST,
    SET_DERMATO_PATIENT_DETAILS,
    MARK_DERMATO_PATIENT_DETAILS_CONSUMED,
  ] = [
    "INIT_DOCUMENT_LOAD",
    "SUBMIT_DOCUMENT_REQUEST",
    "RESET_UPLOAD_STORE",
    "ADD_DOCUMENTS_TO_STORE",
    "SUBMIT_DOCUMENT_ONGOING",
    "SUBMIT_DOCUMENT_SUCCESS",
    "SUBMIT_DOCUMENT_FAILURE",
    "RESET_UPLOAD_STATUS",
    "SEND_ME_UPLOAD_LINK_REQUEST",
    "QR_CODE_LINK_SUCCESS",
    "SEND_ME_UPLOAD_LINK_VIA_SMS_REQUEST",
    "UPLOAD_LINK_VIA_SMS_REQUEST_SUCCESS",
    "FETCH_NEW_DOCUMENT_REQUEST",
    "NEW_DOCS_TRUE",
    "GO_BACK_TO_SURVEY",
    "ADD_DERMATO_PHOTO",
    "ADD_PHONE_PHOTO",
    "CLEAR_UPLOAD_LINK",
    "HYDRATE_UPLOAD",
    "MARK_PHONE_PHOTO_DOCS_PROCESSED",
    "CLEAR_PROCESSED_PHONE_PHOTO_DOCS",
    "FETCH_DERMATO_DETAILS_REQUEST",
    "SET_DERMATO_DETAILS",
    "MARK_DERMATO_DETAILS_CONSUMED",
  ]
  
  export const [
    STATUS_RESOLVED,
    STATUS_REJECTED,
    STATUS_PENDING,
  ] = [
    "RESOLVED",
    "REJECTED",
    "PENDING"
  ]

  export const SMS_LINK = "SMSLINK"

  // Selected patient id of the account holder in the survey answers
  export const MAIN_PATIENT_ID = 0